function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1655",
  "data-name": "Group 1655",
  transform: "translate(-39 -219)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Component_34_43",
  "data-name": "Component 34 \\u2013 43",
  transform: "translate(253.759 254.715) rotate(180)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_10",
  "data-name": "Line 10",
  x1: 17.236,
  transform: "translate(0.273 7.218)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_11",
  "data-name": "Line 11",
  x2: 7.218,
  y2: 7.218,
  transform: "translate(7.218) rotate(90)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_12",
  "data-name": "Line 12",
  y1: 7.218,
  x2: 7.218,
  transform: "translate(7.218 7.218) rotate(90)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Component_34_44",
  "data-name": "Component 34 \\u2013 44",
  transform: "translate(137.759 254.715) rotate(180)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_10-2",
  "data-name": "Line 10",
  x1: 17.236,
  transform: "translate(0.273 7.218)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_11-2",
  "data-name": "Line 11",
  x2: 7.218,
  y2: 7.218,
  transform: "translate(7.218) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_12-2",
  "data-name": "Line 12",
  y1: 7.218,
  x2: 7.218,
  transform: "translate(7.218 7.218) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1591",
  "data-name": "Group 1591",
  transform: "translate(-0.75 -6)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1179",
  "data-name": "Group 1179",
  transform: "translate(41 227)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_989",
  "data-name": "Group 989",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_599",
  "data-name": "Path 599",
  d: "M2.9-.305H26.3V-23.71H2.9Z",
  transform: "translate(-2.898 23.71)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_990",
  "data-name": "Group 990",
  transform: "translate(0 28.594)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_600",
  "data-name": "Path 600",
  d: "M2.9,13.131H26.3V-10.274H2.9Z",
  transform: "translate(-2.898 10.274)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_991",
  "data-name": "Group 991",
  transform: "translate(28.594)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_601",
  "data-name": "Path 601",
  d: "M17-.305H40.4V-23.71H17Z",
  transform: "translate(-16.995 23.71)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_604",
  "data-name": "Path 604",
  d: "M20.418-20.169h7.371",
  transform: "translate(-12.696 30.773)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_992",
  "data-name": "Group 992",
  transform: "translate(28.594 28.594)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_605",
  "data-name": "Path 605",
  d: "M22.954-11.885h15.64V11.521H15.188V-.2H29.873",
  transform: "translate(-15.188 11.885)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1175",
  "data-name": "Group 1175",
  transform: "translate(5.173 43.062) rotate(-90)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_605-2",
  "data-name": "Path 605",
  d: "M3.539,0h7.127V13.71H0V6.844H6.692",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1174",
  "data-name": "Group 1174",
  transform: "translate(34.721 5.106)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_605-3",
  "data-name": "Path 605",
  d: "M19.568-11.885h8.821V-.212h-13.2",
  transform: "translate(-15.188 11.885)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1177",
  "data-name": "Group 1177",
  transform: "translate(16.521 5.106) rotate(90)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_605-4",
  "data-name": "Path 605",
  d: "M4.38,0H13.2V11.673H0",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_760",
  "data-name": "Path 760",
  d: "M0,0H14.341",
  transform: "translate(47.911 33.891) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_759",
  "data-name": "Path 759",
  d: "M6.32-6.733H21.2",
  transform: "translate(22.107 40.624)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_761",
  "data-name": "Path 761",
  d: "M20.418-20.169h5.544",
  transform: "translate(15.14 66.515)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1176",
  "data-name": "Group 1176",
  transform: "translate(5.136 48.169) rotate(-90)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_762",
  "data-name": "Path 762",
  d: "M0,0H9.449",
  transform: "translate(0 0.001) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_763",
  "data-name": "Path 763",
  d: "M0,0H4.814",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1178",
  "data-name": "Group 1178",
  transform: "translate(10.212 5.106)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_762-2",
  "data-name": "Path 762",
  d: "M0,0H8.3",
  transform: "translate(0 0.001) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_763-2",
  "data-name": "Path 763",
  d: "M20.418-20.169h9.61",
  transform: "translate(-20.418 20.169)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1593",
  "data-name": "Group 1593",
  transform: "translate(275.963 284.144)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_589",
  "data-name": "Path 589",
  d: "M53.482-56.256a2.6,2.6,0,0,0-.763-1.841,2.6,2.6,0,0,0-1.841-.763H10.345a2.613,2.613,0,0,0-1.848.765,2.613,2.613,0,0,0-.765,1.848v46.78h45.75Z",
  transform: "translate(-0.703 -0.678)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_590",
  "data-name": "Path 590",
  d: "M16.451-40.392H47v-9.773H16.451Z",
  transform: "translate(-1.821 -1.792)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_591",
  "data-name": "Path 591",
  d: "M26.138-5.946H39.8v-19.79H26.138Z",
  transform: "translate(-3.063 -4.925)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_592",
  "data-name": "Path 592",
  d: "M2.25-2.25H57.1",
  transform: "translate(0 -7.936)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_593",
  "data-name": "Path 593",
  d: "M18.456-64.144H45.048",
  transform: "translate(-2.078)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_864",
  "data-name": "Group 864",
  transform: "translate(-1250.65 -958.105)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_767",
  "data-name": "Group 767",
  transform: "translate(1411 1178.105)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_637",
  "data-name": "Path 637",
  d: "M8.776-27.5v9.59",
  transform: "translate(-0.857 70.886)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_638",
  "data-name": "Path 638",
  d: "M16.277-22.79v4.8",
  transform: "translate(-0.72 70.973)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_639",
  "data-name": "Path 639",
  d: "M6.354-18.082H18.675v1.023H6.354Z",
  transform: "translate(-0.902 71.059)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_640",
  "data-name": "Path 640",
  d: "M42.2-27.5v9.59",
  transform: "translate(-0.244 70.886)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_641",
  "data-name": "Path 641",
  d: "M34.7-22.79v4.8",
  transform: "translate(-0.382 70.973)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_642",
  "data-name": "Path 642",
  d: "M32.519-18.078H44.84v1.018H32.519Z",
  transform: "translate(-0.421 71.06)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_631",
  "data-name": "Path 631",
  d: "M25.836-70.1A24.847,24.847,0,0,1,50.671-45.269,24.847,24.847,0,0,1,25.836-20.433,24.847,24.847,0,0,1,1-45.269,24.847,24.847,0,0,1,25.836-70.1Z",
  transform: "translate(-1 70.104)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_632",
  "data-name": "Path 632",
  d: "M25.734-64.558A19.2,19.2,0,0,1,44.921-45.37,19.2,19.2,0,0,1,25.734-26.183,19.2,19.2,0,0,1,6.547-45.37,19.2,19.2,0,0,1,25.734-64.558Z",
  transform: "translate(-0.898 70.206)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_643",
  "data-name": "Path 643",
  d: "M25.437-48.413a2.748,2.748,0,0,1,2.746,2.746,2.748,2.748,0,0,1-2.746,2.746,2.748,2.748,0,0,1-2.746-2.746A2.748,2.748,0,0,1,25.437-48.413Z",
  transform: "translate(-0.602 70.502)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_644",
  "data-name": "Path 644",
  d: "M7.66-45.716h4.389",
  transform: "translate(-0.878 70.552)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_645",
  "data-name": "Path 645",
  d: "M8.725-51.769l4.126,1.5",
  transform: "translate(-0.858 70.441)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_646",
  "data-name": "Path 646",
  d: "M11.793-57.094l3.366,2.817",
  transform: "translate(-0.802 70.343)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_647",
  "data-name": "Path 647",
  d: "M16.494-61.052l2.2,3.8",
  transform: "translate(-0.716 70.27)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_648",
  "data-name": "Path 648",
  d: "M22.263-63.167l.774,4.321",
  transform: "translate(-0.61 70.232)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_649",
  "data-name": "Path 649",
  d: "M28.422-63.185l-.748,4.325",
  transform: "translate(-0.51 70.231)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_636",
  "data-name": "Path 636",
  d: "M34.23-61.1l-2.18,3.81",
  transform: "translate(-0.43 70.27)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_635",
  "data-name": "Path 635",
  d: "M38.976-57.174l-3.349,2.837",
  transform: "translate(-0.364 70.342)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_633",
  "data-name": "Path 633",
  d: "M42.089-51.868l-4.117,1.523",
  transform: "translate(-0.321 70.439)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_634",
  "data-name": "Path 634",
  d: "M43.195-45.822l-4.389.026",
  transform: "translate(-0.306 70.55)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_650",
  "data-name": "Path 650",
  d: "M32.773-53,27.291-47.52",
  transform: "translate(-0.517 70.418)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_651",
  "data-name": "Path 651",
  d: "M23.585-43.814,18.1-38.331",
  transform: "translate(-0.686 70.587)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_652",
  "data-name": "Path 652",
  d: "M21.636-34.364h2.543v-2.543H21.636Z",
  transform: "translate(-0.621 70.714)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_653",
  "data-name": "Path 653",
  d: "M26.647-34.364H29.19v-2.543H26.647Z",
  transform: "translate(-0.529 70.714)",
  fillRule: "evenodd"
}))));

var SvgAddNewAnalyzer = function SvgAddNewAnalyzer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295.061,
    height: 56,
    viewBox: "0 0 295.061 56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddNewAnalyzer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-new-analyzer.feede283.svg";
export { ForwardRef as ReactComponent };